import cameras from "./cameras"
import mail from "./mail"

export default {
    modules: {
        cameras,
        mail
    }
}
